"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _misc = require("../../misc");
var _SearchableDropdown = _interopRequireDefault(require("./SearchableDropdown.style"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CustomListElement = function CustomListElement(_ref) {
  var label = _ref.label;
  return /*#__PURE__*/_react["default"].createElement("li", {
    key: label
  }, /*#__PURE__*/_react["default"].createElement("button", {
    disabled: true
  }, label));
};
CustomListElement.propTypes = {
  label: _propTypes["default"].string.isRequired
};
var handleSearchableState = function handleSearchableState(_ref2) {
  var children = _ref2.children,
    isSearching = _ref2.isSearching,
    labels = _ref2.labels,
    searchData = _ref2.searchData,
    search = _ref2.search,
    itemClick = _ref2.itemClick;
  if (isSearching) return /*#__PURE__*/_react["default"].createElement(CustomListElement, {
    label: labels.SEARCHING_LABEL
  });
  if ((0, _utils.isBlank)(searchData) && search) {
    return /*#__PURE__*/_react["default"].createElement(CustomListElement, {
      label: labels.NO_RESULTS_FOUND_LABEL
    });
  }
  return searchData.map(function (item) {
    return children && children({
      item: item,
      itemClick: itemClick
    });
  });
};
var SearchableDropdown = function SearchableDropdown(props) {
  var isFocused = props.isFocused,
    searchData = props.searchData,
    search = props.search,
    isFullWidth = props.isFullWidth;
  if (!isFocused || (0, _utils.isBlank)(searchData) && !search) return '';
  return /*#__PURE__*/_react["default"].createElement(_SearchableDropdown["default"], {
    isFullWidth: isFullWidth,
    isScrollable: R.length(searchData) > 5
  }, /*#__PURE__*/_react["default"].createElement(_misc.StyledDropdown, {
    className: "list-menu",
    isFullWidth: isFullWidth
  }, /*#__PURE__*/_react["default"].createElement("ul", null, handleSearchableState(props))));
};
SearchableDropdown.defaultProps = {
  search: '',
  searchData: [],
  isFocused: false,
  isFullWidth: false
};
SearchableDropdown.propTypes = {
  search: _propTypes["default"].string,
  searchData: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string,
    description: _propTypes["default"].string,
    displayName: _propTypes["default"].string,
    dataSource: _propTypes["default"].string
  })),
  isFocused: _propTypes["default"].bool,
  isFullWidth: _propTypes["default"].bool
};
var _default = exports["default"] = SearchableDropdown;